import { useState } from "react";
import InputError from "../../../Components/InputError";
import InputLabel from "../../../Components/InputLabel";
import PrimaryButton from "../../../Components/PrimaryButton";
import TextInput from "../../../Components/TextInput";
import axios from "../../../axios";
import { Button } from '../../../shadcn/ui/button';

export default function UpdatePasswordForm({ className = "" }) {
  const [data, setData] = useState({
    current_password: "",
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const updatePassword = async (e) => {
    e.preventDefault();
    setErrors({});
    setStatus("");

    try {
      await axios.put("/api/password", data);
      setStatus("Password updated successfully.");
      setData({ current_password: "", password: "", password_confirmation: "" });
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setErrors(error.response.data.errors);
      }
    }
  };

  return (
    <section className={className}>
      <header>
        <h2 className="text-lg font-medium text-gray-900">Ενημέρωση κωδικού πρόσβασης</h2>
        <p className="mt-1 text-sm text-gray-600">
        Βεβαιωθείτε ότι ο λογαριασμός σας χρησιμοποιεί έναν μακρύ, τυχαίο κωδικό πρόσβασης για να παραμείνετε ασφαλείς.
        </p>
      </header>

      <form onSubmit={updatePassword} className="mt-6 space-y-6">
        <div>
          <InputLabel htmlFor="current_password" value="Τρέχων κωδικός πρόσβασης" />
          <TextInput
            id="current_password"
            type="password"
            value={data.current_password}
            onChange={(e) => setData({ ...data, current_password: e.target.value })}
            className="mt-1 block w-full"
          />
          <InputError message={errors.current_password} className="mt-2" />
        </div>

        <div>
          <InputLabel htmlFor="password" value="Νέος κωδικός πρόσβασης" />
          <TextInput
            id="password"
            type="password"
            value={data.password}
            onChange={(e) => setData({ ...data, password: e.target.value })}
            className="mt-1 block w-full"
          />
          <InputError message={errors.password} className="mt-2" />
        </div>

        <div>
          <InputLabel htmlFor="password_confirmation" value="Επιβεβαίωση κωδικού πρόσβασης" />
          <TextInput
            id="password_confirmation"
            type="password"
            value={data.password_confirmation}
            onChange={(e) =>
              setData({ ...data, password_confirmation: e.target.value })
            }
            className="mt-1 block w-full"
          />
          <InputError message={errors.password_confirmation} className="mt-2" />
        </div>

        <div className="flex items-center gap-4">
          <Button>Αποθήκευση</Button>
          {status && <p className="text-sm text-green-600">{status}</p>}
        </div>
      </form>
    </section>
  );
}
